import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function CroTestimonials() {
    return (
        <section className="cro-testimonials">
            <Container>
                <div className="section-header cro-reveal">
                    <span className="cro-section-label">Client Feedback</span>
                    <h2 className="cro-section-title">
                        What <span className="highlight">brands say</span> about working with us
                    </h2>
                </div>
                <Row>
                    <Col lg={4} md={6} className="mb-4">
                        <div className="cro-testimonial-card cro-reveal cro-delay-1">
                            <div className="stars">★★★★★</div>
                            <span className="quote-mark">"</span>
                            <p className="testimonial-text">
                                The CRO audit completely changed how we view our landing pages. The AI-assisted insights were spot on and immediately actionable. Our mobile conversions are up by 20% in just a month.
                            </p>
                            <div className="testimonial-author">
                                <div className="author-avatar">MK</div>
                                <div className="author-info">
                                    <span className="author-name">Michael K.</span>
                                    <span className="author-role">eCommerce Founder</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4} md={6} className="mb-4">
                        <div className="cro-testimonial-card cro-reveal cro-delay-2">
                            <div className="stars">★★★★★</div>
                            <span className="quote-mark">"</span>
                            <p className="testimonial-text">
                                We were pouring money into ads without realizing our checkout flow was broken. The experimentation framework gave us a clear, repeatable process to test and win consistently.
                            </p>
                            <div className="testimonial-author">
                                <div className="author-avatar">SR</div>
                                <div className="author-info">
                                    <span className="author-name">Sarah R.</span>
                                    <span className="author-role">Head of Growth, DTC Brand</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4} md={12} className="mb-4">
                        <div className="cro-testimonial-card cro-reveal cro-delay-3">
                            <div className="stars">★★★★★</div>
                            <span className="quote-mark">"</span>
                            <p className="testimonial-text">
                                Their data-driven approach is refreshing. No fluffy recommendations — every suggestion came with evidence, expected impact, and clear implementation steps. ROI was visible in weeks.
                            </p>
                            <div className="testimonial-author">
                                <div className="author-avatar">JL</div>
                                <div className="author-info">
                                    <span className="author-name">James L.</span>
                                    <span className="author-role">CMO, SaaS Platform</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

